import * as frappeSDK from "frappe-react-sdk";
const _f = (frappeSDK as any).default || frappeSDK;
const { useFrappeGetCall } = _f as Pick<typeof frappeSDK, "useFrappeGetCall">;

export interface Address {
  title: string;
  line1: string;
  line2: string;
  city: string;
  state: string;
  pincode: string;
  country: string;
  formatted: string;
}

export interface SocialLink {
  label: string;
  platform: string;
  url: string;
  icon_name: string | null;
  sort_order: number;
  enabled: number;
}

export interface ContactSettings {
  heading: string;
  introduction: string;
  address: Address;
  phone: string;
  email_id: string;
  emergency_phone: string;
  office_hours: string;
  whatsapp: string;
  map_embed_url: string;
  map_direction_url: string;
  social_links: SocialLink[];
  website: string;
}

export const useContactSettings = () => {
  const { data, isLoading, error } = useFrappeGetCall<{ message: ContactSettings }>(
    "health_web.api.contact.get_contact_settings",
    undefined,
    "contact_settings",
  );

  return {
    settings: data?.message ?? null,
    isLoading,
    error,
  };
};
